import { fetchReport } from '../../../services/reportsApi';
import type { TopOffersRequestParams } from './offersReportActions';

const REPORTS_BASE_URL = process.env.REACT_APP_API_ENDPOINT_REPORTS || '';

export const getOffersSummaryApi = (locationId: string, startDate?: string, endDate?: string) => {
  const params = new URLSearchParams({ locationId });
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  return fetchReport(`${REPORTS_BASE_URL}/offers/v1/summary?${params}`);
};

export const getOfferKpiComparisonApi = (locationId: string, startDate?: string, endDate?: string) => {
  const params = new URLSearchParams({ locationId });
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  return fetchReport(`${REPORTS_BASE_URL}/sales/offers/kpi-comparison?${params}`);
};

export const getTopOffersApi = ({
  locationId,
  page,
  size,
  sortBy,
  sortOrder,
  startDate,
  endDate,
  search,
  status,
}: TopOffersRequestParams) => {
  const params = new URLSearchParams({ locationId, page: String(page), size: String(size) });
  if (sortBy) params.set('sortBy', sortBy);
  if (sortOrder) params.set('sortOrder', sortOrder);
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  // ③ Offers-table filters: name search + status (comma-joined enums). Both are
  // omitted when empty so the unfiltered query is unchanged.
  if (search && search.trim()) params.set('search', search.trim());
  if (status) params.set('status', status);
  return fetchReport(`${REPORTS_BASE_URL}/sales/offers/top-offers?${params}`);
};

export const getOfferRedemptionTrendApi = (locationId: string, startDate?: string, endDate?: string) => {
  const params = new URLSearchParams({ locationId });
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  return fetchReport(`${REPORTS_BASE_URL}/sales/offers/redemption-trend?${params}`);
};

export const getOfferDiscountBreakdownApi = (locationId: string, startDate?: string, endDate?: string) => {
  const params = new URLSearchParams({ locationId });
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  return fetchReport(`${REPORTS_BASE_URL}/sales/offers/discount-breakdown?${params}`);
};

export const getOfferDiscountByTypeApi = (locationId: string, startDate?: string, endDate?: string) => {
  const params = new URLSearchParams({ locationId });
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  return fetchReport(`${REPORTS_BASE_URL}/sales/offers/discount-by-type?${params}`);
};

export const getOfferDetailApi = ({
  locationId,
  offerId,
  startDate,
  endDate,
}: {
  locationId: string;
  offerId: string;
  startDate?: string;
  endDate?: string;
}) => {
  const params = new URLSearchParams({ locationId, offerId });
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  return fetchReport(`${REPORTS_BASE_URL}/sales/offers/detail?${params}`);
};
